import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-322740ad"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid-content" }
const _hoisted_2 = { class: "sgrid" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1))
const _hoisted_5 = { class: "col full-width-black-card" }
const _hoisted_6 = { class: "d-flex flex-column text-center" }
const _hoisted_7 = { class: "px-4 mx-auto my-2" }
const _hoisted_8 = { class: "typography-headline white-text" }
const _hoisted_9 = {
  key: 0,
  class: "subtitle-text white-text"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "map-img-background" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1))
const _hoisted_14 = { class: "col full-width-image-card" }
const _hoisted_15 = { class: "d-flex flex-column text-center" }
const _hoisted_16 = { class: "px-4 mx-auto my-2" }
const _hoisted_17 = { class: "typography-headline white-text" }
const _hoisted_18 = {
  key: 0,
  class: "subtitle-text white-text"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1))
const _hoisted_22 = { class: "col full-width-apple-watch-image-card" }
const _hoisted_23 = { class: "d-flex flex-column text-center" }
const _hoisted_24 = { class: "px-4 mx-auto my-2" }
const _hoisted_25 = { class: "typography-headline white-text" }
const _hoisted_26 = {
  key: 0,
  class: "subtitle-text white-text"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1))
const _hoisted_30 = { class: "col full-width-carplay-image-card" }
const _hoisted_31 = { class: "d-flex flex-column text-center" }
const _hoisted_32 = { class: "px-4 mx-auto my-2" }
const _hoisted_33 = { class: "typography-headline white-text" }
const _hoisted_34 = {
  key: 0,
  class: "subtitle-text white-text"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1))
const _hoisted_38 = { class: "col full-width-hunt-image-card" }
const _hoisted_39 = { class: "d-flex flex-column text-center" }
const _hoisted_40 = { class: "px-4 mx-auto my-2" }
const _hoisted_41 = { class: "typography-headline white-text" }
const _hoisted_42 = {
  key: 0,
  class: "subtitle-text white-text"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1))
const _hoisted_46 = { class: "col full-width-hike-image-card" }
const _hoisted_47 = { class: "d-flex flex-column text-center" }
const _hoisted_48 = { class: "px-4 mx-auto my-2" }
const _hoisted_49 = { class: "typography-headline white-text" }
const _hoisted_50 = {
  key: 0,
  class: "subtitle-text white-text"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1))
const _hoisted_54 = { class: "col full-width-enterprise-image-card" }
const _hoisted_55 = { class: "d-flex flex-column text-center" }
const _hoisted_56 = { class: "px-4 mx-auto my-2" }
const _hoisted_57 = { class: "typography-headline white-text" }
const _hoisted_58 = {
  key: 0,
  class: "subtitle-text white-text"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1))
const _hoisted_62 = { class: "col full-width-image-card" }
const _hoisted_63 = { class: "d-flex flex-column text-center" }
const _hoisted_64 = { class: "px-4 mx-auto my-2" }
const _hoisted_65 = { class: "typography-headline white-text" }
const _hoisted_66 = {
  key: 0,
  class: "subtitle-text white-text"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1))
const _hoisted_70 = { class: "col full-width-card" }
const _hoisted_71 = { class: "d-flex flex-column text-center" }
const _hoisted_72 = { class: "px-4 mx-auto my-2" }
const _hoisted_73 = { class: "typography-headline" }
const _hoisted_74 = {
  key: 0,
  class: "subtitle-text"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1))
const _hoisted_78 = { class: "col full-width-title-card" }
const _hoisted_79 = { class: "d-flex flex-column text-center" }
const _hoisted_80 = { class: "px-4 mx-auto my-2" }
const _hoisted_81 = { class: "typography-headline" }
const _hoisted_82 = {
  key: 0,
  class: "subtitle-text"
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1))
const _hoisted_85 = {
  key: 0,
  class: "w-100"
}
const _hoisted_86 = {
  key: 1,
  class: "col card-background"
}
const _hoisted_87 = { class: "d-flex flex-column text-center" }
const _hoisted_88 = { class: "px-4 mx-auto my-2" }
const _hoisted_89 = { class: "typography-headline white-text" }
const _hoisted_90 = {
  key: 0,
  class: "subtitle-tex white-text"
}
const _hoisted_91 = {
  key: 2,
  class: "col card-background-hike-image"
}
const _hoisted_92 = { class: "d-flex flex-column text-center" }
const _hoisted_93 = { class: "px-4 mx-auto my-2" }
const _hoisted_94 = { class: "typography-headline white-text" }
const _hoisted_95 = {
  key: 0,
  class: "subtitle-tex white-text"
}
const _hoisted_96 = {
  key: 3,
  class: "col card-background-hunt-image"
}
const _hoisted_97 = { class: "d-flex flex-column text-center" }
const _hoisted_98 = { class: "px-4 mx-auto my-2" }
const _hoisted_99 = { class: "typography-headline white-text" }
const _hoisted_100 = {
  key: 0,
  class: "subtitle-tex white-text"
}
const _hoisted_101 = { key: 4 }
const _hoisted_102 = ["href"]
const _hoisted_103 = { class: "col full-width-white-card" }
const _hoisted_104 = { class: "" }
const _hoisted_105 = { class: "px-4 mx-auto my-2" }
const _hoisted_106 = ["srcset"]
const _hoisted_107 = ["src"]
const _hoisted_108 = {
  key: 1,
  class: "col full-width-white-card"
}
const _hoisted_109 = { class: "" }
const _hoisted_110 = { class: "px-4 mx-auto my-2" }
const _hoisted_111 = ["srcset"]
const _hoisted_112 = ["src"]
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1))
const _hoisted_114 = ["href"]
const _hoisted_115 = { class: "d-flex flex-column text-center" }
const _hoisted_116 = { class: "px-4 mx-auto my-2" }
const _hoisted_117 = { class: "text-only" }
const _hoisted_118 = {
  key: 1,
  class: "d-flex flex-column text-center"
}
const _hoisted_119 = { class: "px-4 mx-auto my-2 text-only" }
const _hoisted_120 = { class: "text-only" }
const _hoisted_121 = ["href"]
const _hoisted_122 = {
  class: "",
  style: {"display":"flex","flex-direction":"row"}
}
const _hoisted_123 = { style: {"width":"300px"} }
const _hoisted_124 = { class: "vertical-algin" }
const _hoisted_125 = ["srcset"]
const _hoisted_126 = ["src"]
const _hoisted_127 = { class: "vertical-algin" }
const _hoisted_128 = { class: "typography-headline black-text" }
const _hoisted_129 = {
  key: 0,
  class: "subtitle-text black-text"
}
const _hoisted_130 = {
  key: 1,
  class: "text-only"
}
const _hoisted_131 = {
  key: 1,
  class: "",
  style: {"display":"flex","flex-direction":"row"}
}
const _hoisted_132 = { style: {"width":"300px"} }
const _hoisted_133 = { class: "vertical-algin" }
const _hoisted_134 = ["srcset"]
const _hoisted_135 = ["src"]
const _hoisted_136 = { class: "vertical-algin" }
const _hoisted_137 = { class: "typography-headline black-text" }
const _hoisted_138 = {
  key: 0,
  class: "subtitle-text black-text"
}
const _hoisted_139 = {
  key: 1,
  class: "text-only"
}
const _hoisted_140 = ["href"]
const _hoisted_141 = { class: "d-flex flex-column text-center" }
const _hoisted_142 = { class: "px-4 mx-auto my-2" }
const _hoisted_143 = { class: "typography-headline black-text" }
const _hoisted_144 = {
  key: 0,
  class: "subtitle-text black-text"
}
const _hoisted_145 = {
  key: 1,
  class: "text-only"
}
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_147 = ["srcset"]
const _hoisted_148 = ["src"]
const _hoisted_149 = {
  key: 1,
  class: "d-flex flex-column text-center"
}
const _hoisted_150 = { class: "px-4 mx-auto my-2" }
const _hoisted_151 = { class: "typography-headline" }
const _hoisted_152 = {
  key: 0,
  class: "subtitle-text"
}
const _hoisted_153 = {
  key: 1,
  class: "text-only"
}
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_155 = ["srcset"]
const _hoisted_156 = ["src"]
const _hoisted_157 = ["href"]
const _hoisted_158 = {
  class: "",
  style: {"display":"flex","flex-direction":"row"}
}
const _hoisted_159 = { style: {"width":"100px"} }
const _hoisted_160 = { class: "vertical-algin" }
const _hoisted_161 = ["srcset"]
const _hoisted_162 = ["src"]
const _hoisted_163 = { class: "vertical-algin" }
const _hoisted_164 = { class: "typography-headline black-text" }
const _hoisted_165 = {
  key: 0,
  class: "subtitle-text black-text"
}
const _hoisted_166 = {
  key: 1,
  class: "text-only"
}
const _hoisted_167 = {
  key: 1,
  class: "",
  style: {"display":"flex","flex-direction":"row"}
}
const _hoisted_168 = { style: {"width":"100px"} }
const _hoisted_169 = { class: "vertical-algin" }
const _hoisted_170 = ["srcset"]
const _hoisted_171 = ["src"]
const _hoisted_172 = { class: "vertical-algin" }
const _hoisted_173 = { class: "typography-headline black-text" }
const _hoisted_174 = {
  key: 0,
  class: "subtitle-text black-text"
}
const _hoisted_175 = {
  key: 1,
  class: "text-only"
}
const _hoisted_176 = ["href"]
const _hoisted_177 = { class: "d-flex flex-column text-center" }
const _hoisted_178 = { class: "px-4 mx-auto my-2" }
const _hoisted_179 = { class: "typography-headline black-text" }
const _hoisted_180 = {
  key: 0,
  class: "subtitle-text black-text"
}
const _hoisted_181 = {
  key: 1,
  class: "text-only"
}
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_183 = ["srcset"]
const _hoisted_184 = ["src"]
const _hoisted_185 = {
  key: 1,
  class: "d-flex flex-column text-center"
}
const _hoisted_186 = { class: "px-4 mx-auto my-2" }
const _hoisted_187 = { class: "typography-headline" }
const _hoisted_188 = {
  key: 0,
  class: "subtitle-text"
}
const _hoisted_189 = {
  key: 1,
  class: "text-only"
}
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_191 = ["srcset"]
const _hoisted_192 = ["src"]
const _hoisted_193 = {
  key: 8,
  class: "col card"
}
const _hoisted_194 = ["href"]
const _hoisted_195 = { class: "d-flex flex-column text-center" }
const _hoisted_196 = { class: "px-4 mx-auto my-2" }
const _hoisted_197 = { class: "typography-headline black-text" }
const _hoisted_198 = {
  key: 0,
  class: "subtitle-text black-text"
}
const _hoisted_199 = {
  key: 1,
  class: "text-only"
}
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_201 = ["src"]
const _hoisted_202 = {
  key: 1,
  class: "d-flex flex-column text-center"
}
const _hoisted_203 = { class: "px-4 mx-auto my-2" }
const _hoisted_204 = { class: "typography-headline" }
const _hoisted_205 = {
  key: 0,
  class: "subtitle-text"
}
const _hoisted_206 = {
  key: 1,
  class: "text-only"
}
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_208 = ["src"]

import iPhone12 from "@/components/device-screenshots/iPhone12.vue";
import iPhone14Pro from "@/components/device-screenshots/iPhone14Pro.vue";
import iPhone12Small from "@/components/device-screenshots/iPhone12Small.vue";
import iPhone14ProSmall from "@/components/device-screenshots/iPhone14ProSmall.vue";
import iPadPro11Portrait from "@/components/device-screenshots/iPadPro11Portrait.vue"
import iPadPro11PortraitSmall from "@/components/device-screenshots/iPadPro11PortraitSmall.vue"
import GPTextLink from "@/components/modular-page/content-element/GPTextLink.vue";
import { onMounted, ref, computed } from "vue";
import AppleWatchUltra from "./device-screenshots/AppleWatchUltra.vue";
import AppleWatchUltraSmall from "./device-screenshots/AppleWatchUltraSmall.vue";
import MacBookAir13 from "./device-screenshots/MacBookAir13.vue";
import MacBookAir13Small from "./device-screenshots/MacBookAir13Small.vue";

// const props = defineProps<{ amplifyPageId: string }>();


export default /*#__PURE__*/_defineComponent({
  props: {
    gridItems: null,
    maxColumns: null
  },
  setup(__props: any) {

const props = __props as { gridItems: any; maxColumns: number }

_useCssVars(_ctx => ({
  "38501128": (_unref(flexBasis))
}))

const items = ref(null);


function linkTextForItem(item: any) {
  if (item.linkText != null) {
    return item.linkText;
  } else if (item.type == "full-width-image") {
    return "Buy Now";
  } else if (item.link.startsWith("/info/")) {
    return "See How";
  }
  return "Learn More";
}

function addLineBreak(index: number): boolean {
  var lastBreakIndex = 0;
  for (var i = 0; i < items.value.length; i++) {
    var item = items.value[i];
    if (item.type.startsWith("full-width") || item.type == "break") {
      lastBreakIndex = i + 1; //We do a line break starting at the next index

      //We don't do this any more.  This forces a line break after maxColumns,
      //even if due to the screen size there would not be a break here.
      //Set the maxColumns to 4 and then set the screen width so that 3 fit on
      //a column.  The 4th item will have a break after it.
      //We use flex-basis css property instead
    //} else if (i >= lastBreakIndex + props.maxColumns) {
    //  lastBreakIndex = i;
    }
    if (i == index) {
      return lastBreakIndex == i;
    }
  }
  return true;
}

function srcSet(item: any): string {
  return item.imgURL + " 1x, " + item.img2x + " 2x";
}

function classesForCard(item: any): string {
  var classes = "col card ";
  if (item.width == "small") {
    classes += "card-width-small ";
  } else {
    classes += "card-width-normal ";
  }

  if (item.type == "left-image") {
    classes += "card-left-img ";
  } else if (item.type == "image-half") {
    classes += "card-half ";
  } else if (item.type == "full-width-left-image") {
    classes += "card-left-img-full ";
  }

  if (item.border) {
    classes += "card-border ";
  } else {
    classes += "card-no-border ";
  }

  if (item.shadow) {
    classes += "card-shadow ";
  } else if (item.linkCard) {
    classes += "card-hover-state ";
  }

  if (item.background == "medium") {
    classes += "card-darker-background ";
  } else if (item.background == "none") {
    classes += "card-no-background ";
  } else {
    classes += "card-light-background ";
  }

  if (item.autoLeft) {
    if (item.width == "small") {
      classes += "card-height-left-image-for-small-card";
    } else {
      classes += "card-height-left-image-for-normal-card";
    }
  }
  
  
  return classes;
}

function classForLeftImageOnCard(item: any): string {
  if (item.type == "left-image" || item.type == "full-width-left-image") {
    return "always-display";
  } else if (item.autoLeft) {
    if (item.width == "small") {
      return "show-small-screen-for-small-card";
    } else {
      return "show-small-screen-for-normal-card";
    }
  } else {
    return "always-hidden";
  }
}

function classForNormalImageOnCard(item: any): string {
  if (item.type == "left-image" || item.type == "full-width-left-image") {
    return "always-hidden";
  } else if (item.autoLeft) {
    if (item.width == "small") {
      return "show-large-screen-for-small-card";
    } else {
      return "show-large-screen-for-normal-card";
    }
  } else {
    return "always-display";
  }
}

const flexBasis = computed(() => {
  //Since there is blank space around the items, we need to add 1 to the max columns to get the right amount.
  //For 4 columns per row as the max, normally we want 25% as the flex-basis, but since there is some padding
  //we need it to be slightly smaller, so we use 20% instead.
  var per = (1 / (props.maxColumns + 1)) * 100;
  return `${per}%`;
});


onMounted(() => {
  // console.log("onMounted");
  console.log("props.items", props.gridItems);
  items.value = props.gridItems;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (item.type == 'full-width-black')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_4,
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("h2", _hoisted_8, _toDisplayString(item.title), 1),
                        (item.subtitle)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(item.subtitle), 1))
                          : _createCommentVNode("", true),
                        (item.link)
                          ? (_openBlock(), _createBlock(GPTextLink, {
                              key: 1,
                              class: "mb-2 pb-1",
                              traditionalLink: "true",
                              text: linkTextForItem(item),
                              color: "#fff",
                              link: item.link
                            }, null, 8, ["text", "link"]))
                          : _createCommentVNode("", true),
                        _hoisted_10
                      ])
                    ])
                  ]),
                  _hoisted_11,
                  _hoisted_12
                ], 64))
              : (item.type == 'full-width-image')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("h2", _hoisted_17, _toDisplayString(item.title), 1),
                          (item.subtitle)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(item.subtitle), 1))
                            : _createCommentVNode("", true),
                          (item.link)
                            ? (_openBlock(), _createBlock(GPTextLink, {
                                key: 1,
                                class: "mb-2 pb-1",
                                traditionalLink: "true",
                                text: linkTextForItem(item),
                                color: "#fff",
                                link: item.link
                              }, null, 8, ["text", "link"]))
                            : _createCommentVNode("", true),
                          _hoisted_19
                        ])
                      ])
                    ]),
                    _hoisted_20
                  ], 64))
                : (item.type == 'full-width-apple-watch-image')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _hoisted_21,
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("h2", _hoisted_25, _toDisplayString(item.title), 1),
                            (item.subtitle)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(item.subtitle), 1))
                              : _createCommentVNode("", true),
                            (item.link)
                              ? (_openBlock(), _createBlock(GPTextLink, {
                                  key: 1,
                                  class: "mb-2 pb-1",
                                  traditionalLink: "true",
                                  text: linkTextForItem(item),
                                  color: "#fff",
                                  link: item.link
                                }, null, 8, ["text", "link"]))
                              : _createCommentVNode("", true),
                            _hoisted_27
                          ])
                        ])
                      ]),
                      _hoisted_28
                    ], 64))
                  : (item.type == 'full-width-carplay-image')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _hoisted_29,
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("h2", _hoisted_33, _toDisplayString(item.title), 1),
                              (item.subtitle)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(item.subtitle), 1))
                                : _createCommentVNode("", true),
                              (item.link)
                                ? (_openBlock(), _createBlock(GPTextLink, {
                                    key: 1,
                                    class: "mb-2 pb-1",
                                    traditionalLink: "true",
                                    text: linkTextForItem(item),
                                    color: "#fff",
                                    link: item.link
                                  }, null, 8, ["text", "link"]))
                                : _createCommentVNode("", true),
                              _hoisted_35
                            ])
                          ])
                        ]),
                        _hoisted_36
                      ], 64))
                    : (item.type == 'full-width-hunt-image')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          _hoisted_37,
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("div", _hoisted_40, [
                                _createElementVNode("h2", _hoisted_41, _toDisplayString(item.title), 1),
                                (item.subtitle)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(item.subtitle), 1))
                                  : _createCommentVNode("", true),
                                (item.link)
                                  ? (_openBlock(), _createBlock(GPTextLink, {
                                      key: 1,
                                      class: "mb-2 pb-1",
                                      traditionalLink: "true",
                                      text: linkTextForItem(item),
                                      color: "#fff",
                                      link: item.link
                                    }, null, 8, ["text", "link"]))
                                  : _createCommentVNode("", true),
                                _hoisted_43
                              ])
                            ])
                          ]),
                          _hoisted_44
                        ], 64))
                      : (item.type == 'full-width-hike-image')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                            _hoisted_45,
                            _createElementVNode("div", _hoisted_46, [
                              _createElementVNode("div", _hoisted_47, [
                                _createElementVNode("div", _hoisted_48, [
                                  _createElementVNode("h2", _hoisted_49, _toDisplayString(item.title), 1),
                                  (item.subtitle)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_50, _toDisplayString(item.subtitle), 1))
                                    : _createCommentVNode("", true),
                                  (item.link)
                                    ? (_openBlock(), _createBlock(GPTextLink, {
                                        key: 1,
                                        class: "mb-2 pb-1",
                                        traditionalLink: "true",
                                        text: linkTextForItem(item),
                                        color: "#fff",
                                        link: item.link
                                      }, null, 8, ["text", "link"]))
                                    : _createCommentVNode("", true),
                                  _hoisted_51
                                ])
                              ])
                            ]),
                            _hoisted_52
                          ], 64))
                        : (item.type == 'full-width-enterprise-image')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                              _hoisted_53,
                              _createElementVNode("div", _hoisted_54, [
                                _createElementVNode("div", _hoisted_55, [
                                  _createElementVNode("div", _hoisted_56, [
                                    _createElementVNode("h2", _hoisted_57, _toDisplayString(item.title), 1),
                                    (item.subtitle)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_58, _toDisplayString(item.subtitle), 1))
                                      : _createCommentVNode("", true),
                                    (item.link)
                                      ? (_openBlock(), _createBlock(GPTextLink, {
                                          key: 1,
                                          class: "mb-2 pb-1",
                                          traditionalLink: "true",
                                          text: linkTextForItem(item),
                                          color: "#fff",
                                          link: item.link
                                        }, null, 8, ["text", "link"]))
                                      : _createCommentVNode("", true),
                                    _hoisted_59
                                  ])
                                ])
                              ]),
                              _hoisted_60
                            ], 64))
                          : (item.type == 'full-width-image-apple-watch-screenshot')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                _hoisted_61,
                                _createElementVNode("div", _hoisted_62, [
                                  _createElementVNode("div", _hoisted_63, [
                                    _createElementVNode("div", _hoisted_64, [
                                      _createElementVNode("h2", _hoisted_65, _toDisplayString(item.title), 1),
                                      (item.subtitle)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_66, _toDisplayString(item.subtitle), 1))
                                        : _createCommentVNode("", true),
                                      (item.link)
                                        ? (_openBlock(), _createBlock(GPTextLink, {
                                            key: 1,
                                            class: "mb-2 pb-1",
                                            traditionalLink: "true",
                                            text: linkTextForItem(item),
                                            color: "#fff",
                                            link: item.link
                                          }, null, 8, ["text", "link"]))
                                        : _createCommentVNode("", true),
                                      _hoisted_67,
                                      _createVNode(AppleWatchUltra, {
                                        img: item.imgURL
                                      }, null, 8, ["img"])
                                    ])
                                  ])
                                ]),
                                _hoisted_68
                              ], 64))
                            : (item.type == 'full-width-apple-watch-screenshot')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                                  _hoisted_69,
                                  _createElementVNode("div", _hoisted_70, [
                                    _createElementVNode("div", _hoisted_71, [
                                      _createElementVNode("div", _hoisted_72, [
                                        _createElementVNode("h2", _hoisted_73, _toDisplayString(item.title), 1),
                                        (item.subtitle)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_74, _toDisplayString(item.subtitle), 1))
                                          : _createCommentVNode("", true),
                                        (item.link)
                                          ? (_openBlock(), _createBlock(GPTextLink, {
                                              key: 1,
                                              class: "mb-2 pb-1",
                                              traditionalLink: "true",
                                              text: linkTextForItem(item),
                                              link: item.link
                                            }, null, 8, ["text", "link"]))
                                          : _createCommentVNode("", true),
                                        _hoisted_75,
                                        _createVNode(AppleWatchUltra, {
                                          img: item.imgURL
                                        }, null, 8, ["img"])
                                      ])
                                    ])
                                  ]),
                                  _hoisted_76
                                ], 64))
                              : (item.type == 'full-width-section-title')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                                    _hoisted_77,
                                    _createElementVNode("div", _hoisted_78, [
                                      _createElementVNode("div", _hoisted_79, [
                                        _createElementVNode("div", _hoisted_80, [
                                          _createElementVNode("h2", _hoisted_81, _toDisplayString(item.title), 1),
                                          (item.subtitle)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_82, _toDisplayString(item.subtitle), 1))
                                            : _createCommentVNode("", true),
                                          (item.link)
                                            ? (_openBlock(), _createBlock(GPTextLink, {
                                                key: 1,
                                                class: "mb-2 pb-1",
                                                text: linkTextForItem(item),
                                                color: "#fff",
                                                link: item.link
                                              }, null, 8, ["text", "link"]))
                                            : _createCommentVNode("", true),
                                          _hoisted_83
                                        ])
                                      ])
                                    ]),
                                    _hoisted_84
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                                    (addLineBreak(index))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_85))
                                      : _createCommentVNode("", true),
                                    (item.type == 'image-background')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                          _createElementVNode("div", _hoisted_87, [
                                            _createElementVNode("div", _hoisted_88, [
                                              _createElementVNode("h2", _hoisted_89, _toDisplayString(item.title), 1),
                                              (item.subtitle)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_90, _toDisplayString(item.subtitle), 1))
                                                : _createCommentVNode("", true),
                                              (item.link)
                                                ? (_openBlock(), _createBlock(GPTextLink, {
                                                    key: 1,
                                                    class: "mb-2 pb-1",
                                                    traditionalLink: "true",
                                                    color: "#fff",
                                                    text: linkTextForItem(item),
                                                    link: item.link
                                                  }, null, 8, ["text", "link"]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ])
                                        ]))
                                      : (item.type == 'image-background-hike-image')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                            _createElementVNode("div", _hoisted_92, [
                                              _createElementVNode("div", _hoisted_93, [
                                                _createElementVNode("h2", _hoisted_94, _toDisplayString(item.title), 1),
                                                (item.subtitle)
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_95, _toDisplayString(item.subtitle), 1))
                                                  : _createCommentVNode("", true),
                                                (item.link)
                                                  ? (_openBlock(), _createBlock(GPTextLink, {
                                                      key: 1,
                                                      class: "mb-2 pb-1",
                                                      traditionalLink: "true",
                                                      color: "#fff",
                                                      text: linkTextForItem(item),
                                                      link: item.link
                                                    }, null, 8, ["text", "link"]))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ])
                                          ]))
                                        : (item.type == 'image-background-hunt-image')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                              _createElementVNode("div", _hoisted_97, [
                                                _createElementVNode("div", _hoisted_98, [
                                                  _createElementVNode("h2", _hoisted_99, _toDisplayString(item.title), 1),
                                                  (item.subtitle)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_100, _toDisplayString(item.subtitle), 1))
                                                    : _createCommentVNode("", true),
                                                  (item.link)
                                                    ? (_openBlock(), _createBlock(GPTextLink, {
                                                        key: 1,
                                                        class: "mb-2 pb-1",
                                                        traditionalLink: "true",
                                                        color: "#fff",
                                                        text: linkTextForItem(item),
                                                        link: item.link
                                                      }, null, 8, ["text", "link"]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ]))
                                          : (item.type == 'simple-link')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                                (item.linkCard)
                                                  ? (_openBlock(), _createElementBlock("a", {
                                                      key: 0,
                                                      href: item.link
                                                    }, [
                                                      _createElementVNode("div", _hoisted_103, [
                                                        _createElementVNode("div", _hoisted_104, [
                                                          _createElementVNode("div", _hoisted_105, [
                                                            (item.img2x != null)
                                                              ? (_openBlock(), _createElementBlock("img", {
                                                                  key: 0,
                                                                  srcset: srcSet(item),
                                                                  class: "img-fluid",
                                                                  style: {"padding":"8px"}
                                                                }, null, 8, _hoisted_106))
                                                              : (_openBlock(), _createElementBlock("img", {
                                                                  key: 1,
                                                                  src: item.imgURL,
                                                                  srcset: "",
                                                                  class: "img-fluid"
                                                                }, null, 8, _hoisted_107)),
                                                            (item.link)
                                                              ? (_openBlock(), _createBlock(GPTextLink, {
                                                                  key: 2,
                                                                  class: "mb-2 pb-1",
                                                                  text: item.title,
                                                                  link: item.link,
                                                                  style: {"scale":"125%"}
                                                                }, null, 8, ["text", "link"]))
                                                              : _createCommentVNode("", true)
                                                          ])
                                                        ])
                                                      ])
                                                    ], 8, _hoisted_102))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                                      _createElementVNode("div", _hoisted_109, [
                                                        _createElementVNode("div", _hoisted_110, [
                                                          (item.img2x != null)
                                                            ? (_openBlock(), _createElementBlock("img", {
                                                                key: 0,
                                                                srcset: srcSet(item),
                                                                class: "img-fluid",
                                                                style: {"padding":"8px"}
                                                              }, null, 8, _hoisted_111))
                                                            : (_openBlock(), _createElementBlock("img", {
                                                                key: 1,
                                                                src: item.imgURL,
                                                                srcset: "",
                                                                class: "img-fluid"
                                                              }, null, 8, _hoisted_112)),
                                                          (item.link)
                                                            ? (_openBlock(), _createBlock(GPTextLink, {
                                                                key: 2,
                                                                class: "mb-2 pb-1",
                                                                text: item.title,
                                                                link: item.link,
                                                                style: {"scale":"125%"}
                                                              }, null, 8, ["text", "link"]))
                                                            : _createCommentVNode("", true)
                                                        ])
                                                      ])
                                                    ])),
                                                _hoisted_113
                                              ]))
                                            : (item.type == 'text')
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 5,
                                                  class: _normalizeClass(classesForCard(item))
                                                }, [
                                                  (item.linkCard)
                                                    ? (_openBlock(), _createElementBlock("a", {
                                                        key: 0,
                                                        href: item.link
                                                      }, [
                                                        _createElementVNode("div", _hoisted_115, [
                                                          _createElementVNode("div", _hoisted_116, [
                                                            _createElementVNode("div", _hoisted_117, _toDisplayString(item.text), 1)
                                                          ])
                                                        ])
                                                      ], 8, _hoisted_114))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_118, [
                                                        _createElementVNode("div", _hoisted_119, [
                                                          _createElementVNode("div", _hoisted_120, _toDisplayString(item.text), 1)
                                                        ])
                                                      ]))
                                                ], 2))
                                              : (item.type == 'full-width-left-image')
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 6,
                                                    class: _normalizeClass(classesForCard(item))
                                                  }, [
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(classForLeftImageOnCard(item))
                                                    }, [
                                                      _createElementVNode("div", null, [
                                                        (item.linkCard)
                                                          ? (_openBlock(), _createElementBlock("a", {
                                                              key: 0,
                                                              href: item.link
                                                            }, [
                                                              _createElementVNode("div", _hoisted_122, [
                                                                _createElementVNode("div", _hoisted_123, [
                                                                  _createElementVNode("div", _hoisted_124, [
                                                                    (item.bezel == 'iPhone')
                                                                      ? (_openBlock(), _createBlock(iPhone12, {
                                                                          key: 0,
                                                                          img: item.imgURL
                                                                        }, null, 8, ["img"]))
                                                                      : (item.bezel == 'iPhone14Pro')
                                                                        ? (_openBlock(), _createBlock(iPhone14Pro, {
                                                                            key: 1,
                                                                            img: item.imgURL
                                                                          }, null, 8, ["img"]))
                                                                        : (item.bezel == 'iPad')
                                                                          ? (_openBlock(), _createBlock(iPadPro11Portrait, {
                                                                              key: 2,
                                                                              img: item.imgURL
                                                                            }, null, 8, ["img"]))
                                                                          : (item.bezel == 'apple-watch')
                                                                            ? (_openBlock(), _createBlock(AppleWatchUltra, {
                                                                                key: 3,
                                                                                img: item.imgURL
                                                                              }, null, 8, ["img"]))
                                                                            : (item.bezel == 'mac')
                                                                              ? (_openBlock(), _createBlock(MacBookAir13, {
                                                                                  key: 4,
                                                                                  img: item.imgURL
                                                                                }, null, 8, ["img"]))
                                                                              : (item.img2x != null)
                                                                                ? (_openBlock(), _createElementBlock("img", {
                                                                                    key: 5,
                                                                                    srcset: srcSet(item),
                                                                                    class: "img-fluid grid-img-max-height grid-img-max-width"
                                                                                  }, null, 8, _hoisted_125))
                                                                                : (_openBlock(), _createElementBlock("img", {
                                                                                    key: 6,
                                                                                    src: item.imgURL,
                                                                                    class: "img-fluid grid-img-max-height grid-img-max-width"
                                                                                  }, null, 8, _hoisted_126))
                                                                  ])
                                                                ]),
                                                                _createElementVNode("div", null, [
                                                                  _createElementVNode("div", _hoisted_127, [
                                                                    _createElementVNode("h2", _hoisted_128, _toDisplayString(item.title), 1),
                                                                    (item.subtitle)
                                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_129, _toDisplayString(item.subtitle), 1))
                                                                      : _createCommentVNode("", true),
                                                                    (item.text)
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_130, _toDisplayString(item.text), 1))
                                                                      : _createCommentVNode("", true),
                                                                    (item.link && item.linkText)
                                                                      ? (_openBlock(), _createBlock(GPTextLink, {
                                                                          key: 2,
                                                                          class: "mb-2 pb-1",
                                                                          text: linkTextForItem(item),
                                                                          link: item.link
                                                                        }, null, 8, ["text", "link"]))
                                                                      : _createCommentVNode("", true)
                                                                  ])
                                                                ])
                                                              ])
                                                            ], 8, _hoisted_121))
                                                          : (_openBlock(), _createElementBlock("div", _hoisted_131, [
                                                              _createElementVNode("div", _hoisted_132, [
                                                                _createElementVNode("div", _hoisted_133, [
                                                                  (item.bezel == 'iPhone')
                                                                    ? (_openBlock(), _createBlock(iPhone12, {
                                                                        key: 0,
                                                                        img: item.imgURL
                                                                      }, null, 8, ["img"]))
                                                                    : (item.bezel == 'iPhone14Pro')
                                                                      ? (_openBlock(), _createBlock(iPhone14Pro, {
                                                                          key: 1,
                                                                          img: item.imgURL
                                                                        }, null, 8, ["img"]))
                                                                      : (item.bezel == 'iPad')
                                                                        ? (_openBlock(), _createBlock(iPadPro11Portrait, {
                                                                            key: 2,
                                                                            img: item.imgURL
                                                                          }, null, 8, ["img"]))
                                                                        : (item.bezel == 'apple-watch')
                                                                          ? (_openBlock(), _createBlock(AppleWatchUltra, {
                                                                              key: 3,
                                                                              img: item.imgURL
                                                                            }, null, 8, ["img"]))
                                                                          : (item.bezel == 'mac')
                                                                            ? (_openBlock(), _createBlock(MacBookAir13, {
                                                                                key: 4,
                                                                                img: item.imgURL
                                                                              }, null, 8, ["img"]))
                                                                            : (item.img2x != null)
                                                                              ? (_openBlock(), _createElementBlock("img", {
                                                                                  key: 5,
                                                                                  srcset: srcSet(item),
                                                                                  class: "img-fluid grid-img-max-height grid-img-max-width"
                                                                                }, null, 8, _hoisted_134))
                                                                              : (_openBlock(), _createElementBlock("img", {
                                                                                  key: 6,
                                                                                  src: item.imgURL,
                                                                                  class: "img-fluid grid-img-max-height grid-img-max-width"
                                                                                }, null, 8, _hoisted_135))
                                                                ])
                                                              ]),
                                                              _createElementVNode("div", null, [
                                                                _createElementVNode("div", _hoisted_136, [
                                                                  _createElementVNode("h2", _hoisted_137, _toDisplayString(item.title), 1),
                                                                  (item.subtitle)
                                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_138, _toDisplayString(item.subtitle), 1))
                                                                    : _createCommentVNode("", true),
                                                                  (item.text)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_139, _toDisplayString(item.text), 1))
                                                                    : _createCommentVNode("", true),
                                                                  (item.link && item.linkText)
                                                                    ? (_openBlock(), _createBlock(GPTextLink, {
                                                                        key: 2,
                                                                        class: "mb-2 pb-1",
                                                                        text: linkTextForItem(item),
                                                                        link: item.link
                                                                      }, null, 8, ["text", "link"]))
                                                                    : _createCommentVNode("", true)
                                                                ])
                                                              ])
                                                            ]))
                                                      ])
                                                    ], 2),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(classForNormalImageOnCard(item))
                                                    }, [
                                                      (item.linkCard)
                                                        ? (_openBlock(), _createElementBlock("a", {
                                                            key: 0,
                                                            href: item.link
                                                          }, [
                                                            _createElementVNode("div", _hoisted_141, [
                                                              _createElementVNode("div", _hoisted_142, [
                                                                _createElementVNode("h2", _hoisted_143, _toDisplayString(item.title), 1),
                                                                (item.subtitle)
                                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_144, _toDisplayString(item.subtitle), 1))
                                                                  : _createCommentVNode("", true),
                                                                (item.text)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_145, _toDisplayString(item.text), 1))
                                                                  : _createCommentVNode("", true),
                                                                (item.link && item.linkText)
                                                                  ? (_openBlock(), _createBlock(GPTextLink, {
                                                                      key: 2,
                                                                      class: "mb-2 pb-1",
                                                                      traditionalLink: "true",
                                                                      text: linkTextForItem(item),
                                                                      link: item.link
                                                                    }, null, 8, ["text", "link"]))
                                                                  : _createCommentVNode("", true),
                                                                _hoisted_146,
                                                                (item.bezel == 'iPhone')
                                                                  ? (_openBlock(), _createBlock(iPhone12, {
                                                                      key: 3,
                                                                      img: item.imgURL
                                                                    }, null, 8, ["img"]))
                                                                  : (item.bezel == 'iPhone14Pro')
                                                                    ? (_openBlock(), _createBlock(iPhone14Pro, {
                                                                        key: 4,
                                                                        img: item.imgURL
                                                                      }, null, 8, ["img"]))
                                                                    : (item.bezel == 'iPad')
                                                                      ? (_openBlock(), _createBlock(iPadPro11Portrait, {
                                                                          key: 5,
                                                                          img: item.imgURL
                                                                        }, null, 8, ["img"]))
                                                                      : (item.bezel == 'apple-watch')
                                                                        ? (_openBlock(), _createBlock(AppleWatchUltra, {
                                                                            key: 6,
                                                                            img: item.imgURL
                                                                          }, null, 8, ["img"]))
                                                                        : (item.bezel == 'mac')
                                                                          ? (_openBlock(), _createBlock(MacBookAir13, {
                                                                              key: 7,
                                                                              img: item.imgURL
                                                                            }, null, 8, ["img"]))
                                                                          : (item.img2x != null)
                                                                            ? (_openBlock(), _createElementBlock("img", {
                                                                                key: 8,
                                                                                srcset: srcSet(item),
                                                                                class: "img-fluid grid-img-max-height grid-img-max-width"
                                                                              }, null, 8, _hoisted_147))
                                                                            : (_openBlock(), _createElementBlock("img", {
                                                                                key: 9,
                                                                                src: item.imgURL,
                                                                                class: "img-fluid grid-img-max-height grid-img-max-width"
                                                                              }, null, 8, _hoisted_148))
                                                              ])
                                                            ])
                                                          ], 8, _hoisted_140))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_149, [
                                                            _createElementVNode("div", _hoisted_150, [
                                                              _createElementVNode("h2", _hoisted_151, _toDisplayString(item.title), 1),
                                                              (item.subtitle)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_152, _toDisplayString(item.subtitle), 1))
                                                                : _createCommentVNode("", true),
                                                              (item.text)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_153, _toDisplayString(item.text), 1))
                                                                : _createCommentVNode("", true),
                                                              (item.link)
                                                                ? (_openBlock(), _createBlock(GPTextLink, {
                                                                    key: 2,
                                                                    class: "mb-2 pb-1",
                                                                    traditionalLink: "true",
                                                                    text: linkTextForItem(item),
                                                                    link: item.link
                                                                  }, null, 8, ["text", "link"]))
                                                                : _createCommentVNode("", true),
                                                              _hoisted_154,
                                                              (item.bezel == 'iPhone')
                                                                ? (_openBlock(), _createBlock(iPhone12, {
                                                                    key: 3,
                                                                    img: item.imgURL
                                                                  }, null, 8, ["img"]))
                                                                : (item.bezel == 'iPhone14Pro')
                                                                  ? (_openBlock(), _createBlock(iPhone14Pro, {
                                                                      key: 4,
                                                                      img: item.imgURL
                                                                    }, null, 8, ["img"]))
                                                                  : (item.bezel == 'iPad')
                                                                    ? (_openBlock(), _createBlock(iPadPro11Portrait, {
                                                                        key: 5,
                                                                        img: item.imgURL
                                                                      }, null, 8, ["img"]))
                                                                    : (item.bezel == 'apple-watch')
                                                                      ? (_openBlock(), _createBlock(AppleWatchUltra, {
                                                                          key: 6,
                                                                          img: item.imgURL
                                                                        }, null, 8, ["img"]))
                                                                      : (item.bezel == 'mac')
                                                                        ? (_openBlock(), _createBlock(MacBookAir13, {
                                                                            key: 7,
                                                                            img: item.imgURL
                                                                          }, null, 8, ["img"]))
                                                                        : (item.img2x != null)
                                                                          ? (_openBlock(), _createElementBlock("img", {
                                                                              key: 8,
                                                                              srcset: srcSet(item),
                                                                              class: "img-fluid grid-img-max-height grid-img-max-width"
                                                                            }, null, 8, _hoisted_155))
                                                                          : (_openBlock(), _createElementBlock("img", {
                                                                              key: 9,
                                                                              src: item.imgURL,
                                                                              class: "img-fluid grid-img-max-height grid-img-max-width"
                                                                            }, null, 8, _hoisted_156))
                                                            ])
                                                          ]))
                                                    ], 2)
                                                  ], 2))
                                                : (item.type == 'image' || item.type == 'image-half' || item.type == 'left-image')
                                                  ? (_openBlock(), _createElementBlock("div", {
                                                      key: 7,
                                                      class: _normalizeClass(classesForCard(item))
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(classForLeftImageOnCard(item))
                                                      }, [
                                                        _createElementVNode("div", null, [
                                                          (item.linkCard)
                                                            ? (_openBlock(), _createElementBlock("a", {
                                                                key: 0,
                                                                href: item.link
                                                              }, [
                                                                _createElementVNode("div", _hoisted_158, [
                                                                  _createElementVNode("div", _hoisted_159, [
                                                                    _createElementVNode("div", _hoisted_160, [
                                                                      (item.bezel == 'iPhone')
                                                                        ? (_openBlock(), _createBlock(iPhone12Small, {
                                                                            key: 0,
                                                                            img: item.imgURL
                                                                          }, null, 8, ["img"]))
                                                                        : (item.bezel == 'iPhone14Pro')
                                                                          ? (_openBlock(), _createBlock(iPhone14ProSmall, {
                                                                              key: 1,
                                                                              img: item.imgURL
                                                                            }, null, 8, ["img"]))
                                                                          : (item.bezel == 'iPad')
                                                                            ? (_openBlock(), _createBlock(iPadPro11PortraitSmall, {
                                                                                key: 2,
                                                                                img: item.imgURL
                                                                              }, null, 8, ["img"]))
                                                                            : (item.bezel == 'apple-watch')
                                                                              ? (_openBlock(), _createBlock(AppleWatchUltraSmall, {
                                                                                  key: 3,
                                                                                  img: item.imgURL
                                                                                }, null, 8, ["img"]))
                                                                              : (item.bezel == 'mac')
                                                                                ? (_openBlock(), _createBlock(MacBookAir13Small, {
                                                                                    key: 4,
                                                                                    img: item.imgURL
                                                                                  }, null, 8, ["img"]))
                                                                                : (item.img2x != null)
                                                                                  ? (_openBlock(), _createElementBlock("img", {
                                                                                      key: 5,
                                                                                      srcset: srcSet(item),
                                                                                      class: "img-fluid left-img"
                                                                                    }, null, 8, _hoisted_161))
                                                                                  : (_openBlock(), _createElementBlock("img", {
                                                                                      key: 6,
                                                                                      src: item.imgURL,
                                                                                      srcset: "",
                                                                                      class: "img-fluid left-img"
                                                                                    }, null, 8, _hoisted_162))
                                                                    ])
                                                                  ]),
                                                                  _createElementVNode("div", null, [
                                                                    _createElementVNode("div", _hoisted_163, [
                                                                      _createElementVNode("h2", _hoisted_164, _toDisplayString(item.title), 1),
                                                                      (item.subtitle)
                                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_165, _toDisplayString(item.subtitle), 1))
                                                                        : _createCommentVNode("", true),
                                                                      (item.text)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_166, _toDisplayString(item.text), 1))
                                                                        : _createCommentVNode("", true),
                                                                      (item.link && item.linkText)
                                                                        ? (_openBlock(), _createBlock(GPTextLink, {
                                                                            key: 2,
                                                                            class: "mb-2 pb-1",
                                                                            text: linkTextForItem(item),
                                                                            link: item.link
                                                                          }, null, 8, ["text", "link"]))
                                                                        : _createCommentVNode("", true)
                                                                    ])
                                                                  ])
                                                                ])
                                                              ], 8, _hoisted_157))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_167, [
                                                                _createElementVNode("div", _hoisted_168, [
                                                                  _createElementVNode("div", _hoisted_169, [
                                                                    (item.bezel == 'iPhone')
                                                                      ? (_openBlock(), _createBlock(iPhone12Small, {
                                                                          key: 0,
                                                                          img: item.imgURL
                                                                        }, null, 8, ["img"]))
                                                                      : (item.bezel == 'iPhone14Pro')
                                                                        ? (_openBlock(), _createBlock(iPhone14ProSmall, {
                                                                            key: 1,
                                                                            img: item.imgURL
                                                                          }, null, 8, ["img"]))
                                                                        : (item.bezel == 'iPad')
                                                                          ? (_openBlock(), _createBlock(iPadPro11PortraitSmall, {
                                                                              key: 2,
                                                                              img: item.imgURL
                                                                            }, null, 8, ["img"]))
                                                                          : (item.bezel == 'apple-watch')
                                                                            ? (_openBlock(), _createBlock(AppleWatchUltraSmall, {
                                                                                key: 3,
                                                                                img: item.imgURL
                                                                              }, null, 8, ["img"]))
                                                                            : (item.bezel == 'mac')
                                                                              ? (_openBlock(), _createBlock(MacBookAir13Small, {
                                                                                  key: 4,
                                                                                  img: item.imgURL
                                                                                }, null, 8, ["img"]))
                                                                              : (item.img2x != null)
                                                                                ? (_openBlock(), _createElementBlock("img", {
                                                                                    key: 5,
                                                                                    srcset: srcSet(item),
                                                                                    class: "img-fluid left-img"
                                                                                  }, null, 8, _hoisted_170))
                                                                                : (_openBlock(), _createElementBlock("img", {
                                                                                    key: 6,
                                                                                    src: item.imgURL,
                                                                                    srcset: "",
                                                                                    class: "img-fluid left-img"
                                                                                  }, null, 8, _hoisted_171))
                                                                  ])
                                                                ]),
                                                                _createElementVNode("div", null, [
                                                                  _createElementVNode("div", _hoisted_172, [
                                                                    _createElementVNode("h2", _hoisted_173, _toDisplayString(item.title), 1),
                                                                    (item.subtitle)
                                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_174, _toDisplayString(item.subtitle), 1))
                                                                      : _createCommentVNode("", true),
                                                                    (item.text)
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_175, _toDisplayString(item.text), 1))
                                                                      : _createCommentVNode("", true),
                                                                    (item.link && item.linkText)
                                                                      ? (_openBlock(), _createBlock(GPTextLink, {
                                                                          key: 2,
                                                                          class: "mb-2 pb-1",
                                                                          text: linkTextForItem(item),
                                                                          link: item.link
                                                                        }, null, 8, ["text", "link"]))
                                                                      : _createCommentVNode("", true)
                                                                  ])
                                                                ])
                                                              ]))
                                                        ])
                                                      ], 2),
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(classForNormalImageOnCard(item))
                                                      }, [
                                                        (item.linkCard)
                                                          ? (_openBlock(), _createElementBlock("a", {
                                                              key: 0,
                                                              href: item.link
                                                            }, [
                                                              _createElementVNode("div", _hoisted_177, [
                                                                _createElementVNode("div", _hoisted_178, [
                                                                  _createElementVNode("h2", _hoisted_179, _toDisplayString(item.title), 1),
                                                                  (item.subtitle)
                                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_180, _toDisplayString(item.subtitle), 1))
                                                                    : _createCommentVNode("", true),
                                                                  (item.text)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_181, _toDisplayString(item.text), 1))
                                                                    : _createCommentVNode("", true),
                                                                  (item.link && item.linkText)
                                                                    ? (_openBlock(), _createBlock(GPTextLink, {
                                                                        key: 2,
                                                                        class: "mb-2 pb-1",
                                                                        traditionalLink: "true",
                                                                        text: linkTextForItem(item),
                                                                        link: item.link
                                                                      }, null, 8, ["text", "link"]))
                                                                    : _createCommentVNode("", true),
                                                                  _hoisted_182,
                                                                  (item.bezel == 'iPhone')
                                                                    ? (_openBlock(), _createBlock(iPhone12, {
                                                                        key: 3,
                                                                        img: item.imgURL
                                                                      }, null, 8, ["img"]))
                                                                    : (item.bezel == 'iPhone14Pro')
                                                                      ? (_openBlock(), _createBlock(iPhone14Pro, {
                                                                          key: 4,
                                                                          img: item.imgURL
                                                                        }, null, 8, ["img"]))
                                                                      : (item.bezel == 'iPad')
                                                                        ? (_openBlock(), _createBlock(iPadPro11Portrait, {
                                                                            key: 5,
                                                                            img: item.imgURL
                                                                          }, null, 8, ["img"]))
                                                                        : (item.bezel == 'apple-watch')
                                                                          ? (_openBlock(), _createBlock(AppleWatchUltra, {
                                                                              key: 6,
                                                                              img: item.imgURL
                                                                            }, null, 8, ["img"]))
                                                                          : (item.bezel == 'mac')
                                                                            ? (_openBlock(), _createBlock(MacBookAir13, {
                                                                                key: 7,
                                                                                img: item.imgURL
                                                                              }, null, 8, ["img"]))
                                                                            : (item.img2x != null)
                                                                              ? (_openBlock(), _createElementBlock("img", {
                                                                                  key: 8,
                                                                                  srcset: srcSet(item),
                                                                                  class: "img-fluid grid-img-max-height grid-img-max-width"
                                                                                }, null, 8, _hoisted_183))
                                                                              : (_openBlock(), _createElementBlock("img", {
                                                                                  key: 9,
                                                                                  src: item.imgURL,
                                                                                  class: "img-fluid grid-img-max-height grid-img-max-width"
                                                                                }, null, 8, _hoisted_184))
                                                                ])
                                                              ])
                                                            ], 8, _hoisted_176))
                                                          : (_openBlock(), _createElementBlock("div", _hoisted_185, [
                                                              _createElementVNode("div", _hoisted_186, [
                                                                _createElementVNode("h2", _hoisted_187, _toDisplayString(item.title), 1),
                                                                (item.subtitle)
                                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_188, _toDisplayString(item.subtitle), 1))
                                                                  : _createCommentVNode("", true),
                                                                (item.text)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_189, _toDisplayString(item.text), 1))
                                                                  : _createCommentVNode("", true),
                                                                (item.link)
                                                                  ? (_openBlock(), _createBlock(GPTextLink, {
                                                                      key: 2,
                                                                      class: "mb-2 pb-1",
                                                                      traditionalLink: "true",
                                                                      text: linkTextForItem(item),
                                                                      link: item.link
                                                                    }, null, 8, ["text", "link"]))
                                                                  : _createCommentVNode("", true),
                                                                _hoisted_190,
                                                                (item.bezel == 'iPhone')
                                                                  ? (_openBlock(), _createBlock(iPhone12, {
                                                                      key: 3,
                                                                      img: item.imgURL
                                                                    }, null, 8, ["img"]))
                                                                  : (item.bezel == 'iPhone14Pro')
                                                                    ? (_openBlock(), _createBlock(iPhone14Pro, {
                                                                        key: 4,
                                                                        img: item.imgURL
                                                                      }, null, 8, ["img"]))
                                                                    : (item.bezel == 'iPad')
                                                                      ? (_openBlock(), _createBlock(iPadPro11Portrait, {
                                                                          key: 5,
                                                                          img: item.imgURL
                                                                        }, null, 8, ["img"]))
                                                                      : (item.bezel == 'apple-watch')
                                                                        ? (_openBlock(), _createBlock(AppleWatchUltra, {
                                                                            key: 6,
                                                                            img: item.imgURL
                                                                          }, null, 8, ["img"]))
                                                                        : (item.bezel == 'mac')
                                                                          ? (_openBlock(), _createBlock(MacBookAir13, {
                                                                              key: 7,
                                                                              img: item.imgURL
                                                                            }, null, 8, ["img"]))
                                                                          : (item.img2x != null)
                                                                            ? (_openBlock(), _createElementBlock("img", {
                                                                                key: 8,
                                                                                srcset: srcSet(item),
                                                                                class: "img-fluid grid-img-max-height grid-img-max-width"
                                                                              }, null, 8, _hoisted_191))
                                                                            : (_openBlock(), _createElementBlock("img", {
                                                                                key: 9,
                                                                                src: item.imgURL,
                                                                                class: "img-fluid grid-img-max-height grid-img-max-width"
                                                                              }, null, 8, _hoisted_192))
                                                              ])
                                                            ]))
                                                      ], 2)
                                                    ], 2))
                                                  : (item.type != 'break')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_193, [
                                                        (item.linkCard)
                                                          ? (_openBlock(), _createElementBlock("a", {
                                                              key: 0,
                                                              href: item.link
                                                            }, [
                                                              _createElementVNode("div", _hoisted_195, [
                                                                _createElementVNode("div", _hoisted_196, [
                                                                  _createElementVNode("h2", _hoisted_197, _toDisplayString(item.title), 1),
                                                                  (item.subtitle)
                                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_198, _toDisplayString(item.subtitle), 1))
                                                                    : _createCommentVNode("", true),
                                                                  (item.text)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_199, _toDisplayString(item.text), 1))
                                                                    : _createCommentVNode("", true),
                                                                  (item.link && item.linkText)
                                                                    ? (_openBlock(), _createBlock(GPTextLink, {
                                                                        key: 2,
                                                                        class: "mb-2 pb-1",
                                                                        traditionalLink: "true",
                                                                        text: linkTextForItem(item),
                                                                        link: item.link
                                                                      }, null, 8, ["text", "link"]))
                                                                    : _createCommentVNode("", true),
                                                                  _hoisted_200,
                                                                  _createElementVNode("img", {
                                                                    src: item.imgURL,
                                                                    class: "img-fluid grid-img-max-height grid-img-max-width"
                                                                  }, null, 8, _hoisted_201)
                                                                ])
                                                              ])
                                                            ], 8, _hoisted_194))
                                                          : (_openBlock(), _createElementBlock("div", _hoisted_202, [
                                                              _createElementVNode("div", _hoisted_203, [
                                                                _createElementVNode("h2", _hoisted_204, _toDisplayString(item.title), 1),
                                                                (item.subtitle)
                                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_205, _toDisplayString(item.subtitle), 1))
                                                                  : _createCommentVNode("", true),
                                                                (item.text)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_206, _toDisplayString(item.text), 1))
                                                                  : _createCommentVNode("", true),
                                                                (item.link)
                                                                  ? (_openBlock(), _createBlock(GPTextLink, {
                                                                      key: 2,
                                                                      class: "mb-2 pb-1",
                                                                      traditionalLink: "true",
                                                                      text: linkTextForItem(item),
                                                                      link: item.link
                                                                    }, null, 8, ["text", "link"]))
                                                                  : _createCommentVNode("", true),
                                                                _hoisted_207,
                                                                _createElementVNode("img", {
                                                                  src: item.imgURL,
                                                                  class: "img-fluid grid-img-max-height grid-img-max-width"
                                                                }, null, 8, _hoisted_208)
                                                              ])
                                                            ]))
                                                      ]))
                                                    : _createCommentVNode("", true)
                                  ], 64))
          ], 64))
        }), 128))
      ])
    ])
  ]))
}
}

})